export const CTA_ON_MOBILE_NAV_EXP_FLAG = 'pen-5294_v1'
